<template>
  <div :class="$style.container">
    <div :class="$style.left">
      <user-info :hasNav="hasNav" />
    </div>

    <a
      :href="appUrl"
      target="_blank"
      title="Open Jiminny app"
      :class="$style.appLink"><img :src="jiminnyLogo" alt="Jiminny Logo" /></a>

    <div :class="$style.right">
    </div>
  </div>
</template>

<script>
  import { jiminnyHost } from '@/helpers/region'
  import jiminnyLogo from '@/assets/img/sidekick_white.svg'
  import UserInfo from './user-info'

  export default {
    components: {
      UserInfo
    },
    props: [
      'hasNav'
    ],
    data () {
      return {
        jiminnyLogo
      }
    },
    computed: {
      appUrl () {
        return jiminnyHost()
      }
    }
  }
</script>

<style module lang="less" src="./header-top.less"></style>



// WEBPACK FOOTER //
// header-top.vue?39b85d7c